import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxBaseUiOptions } from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";
import { DxHeadNavigationMenuOptions } from "./dx-head-navigation-menu-options";
import { DxSideNavigationMenuOptions } from "./dx-side-navigation-menu-options";
/**
 * Опции навигатора.
 * @publicApi
 */
let DxNavigatorOptions = class DxNavigatorOptions extends DxBaseUiOptions {
    /**
     * Опции навигатора.
     * @publicApi
     */
    constructor() {
        super(...arguments);
        this._mode = 'TOP';
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    get homeRoute() {
        return this._homeRoute;
    }
    set homeRoute(value) {
        this._homeRoute = value;
    }
    get navigatorRoute() {
        return this._navigatorRoute;
    }
    get headNavigationMenuOptions() {
        return this._headNavigationMenuOptions;
    }
    get defaultRoute() {
        return this._defaultRoute;
    }
    set defaultRoute(value) {
        this._defaultRoute = value;
    }
    set headNavigationMenuOptions(value) {
        this._headNavigationMenuOptions = value;
    }
    get sideNavigationMenuOptions() {
        return this._sideNavigationMenuOptions;
    }
    set sideNavigationMenuOptions(value) {
        this._sideNavigationMenuOptions = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "mode", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNavigatorOptions.prototype, "_mode", void 0);
tslib_1.__decorate([
    jsonMember({ name: "homeRoute", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNavigatorOptions.prototype, "_homeRoute", void 0);
tslib_1.__decorate([
    jsonMember({ name: "navigatorRoute", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNavigatorOptions.prototype, "_navigatorRoute", void 0);
tslib_1.__decorate([
    jsonMember({ name: "defaultRoute", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNavigatorOptions.prototype, "_defaultRoute", void 0);
tslib_1.__decorate([
    jsonMember({ name: "headNavigationMenuOptions", constructor: DxHeadNavigationMenuOptions, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", DxHeadNavigationMenuOptions)
], DxNavigatorOptions.prototype, "_headNavigationMenuOptions", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sideNavigationMenuOptions", constructor: DxSideNavigationMenuOptions, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", DxSideNavigationMenuOptions)
], DxNavigatorOptions.prototype, "_sideNavigationMenuOptions", void 0);
DxNavigatorOptions = tslib_1.__decorate([
    jsonObject
], DxNavigatorOptions);
export { DxNavigatorOptions };
